import { useParams } from 'react-router-dom';
import { ECoinsPaywallReason } from 'src/services/analytics/events';
import { useSearchQuery } from 'src/hooks/useSearchQuery';
import { useAccountSelect } from 'src/hooks/useAccount';
import { useDialogSelect } from 'src/hooks/useDialog';
export {
  ECoinsPaywallReason
}
interface IModalPaywalHeartOpenParams {
  redirectPage?: string;
  redirectModal?: string;
  reason: `${ECoinsPaywallReason}`
  dialogId?: string;
  botName?: string;
  priority_category?: string
  message_id?:string;
}
interface IModalPaywalHeartQueryParams extends IModalPaywalHeartOpenParams{
  modal: 'paywall-heart' | 'auth';

}
export const useModalPaywallHeart = ()=> {
  const dialogHistory = useDialogSelect.dialogHistory()
  const bot = useDialogSelect.bot()
  const { chatId } = useParams()
  const isUser = useAccountSelect.isUser();
  const isAnonymous = useAccountSelect.isAnonymous();

  const search = useSearchQuery<IModalPaywalHeartQueryParams>();
  const open = (params: IModalPaywalHeartOpenParams) => {
    if (!isUser) return;

    // Если пользователь анонимный - редиректим на форму регистрации
    if (isAnonymous) {
      search.setQuery({
        modal: 'auth',
        redirectModal: 'paywall-heart',
        dialogId: chatId ? dialogHistory?.id?.toString() : params.dialogId,
        botName: chatId ? bot?.name : params.botName,
        priority_category: bot?.priority_category || params.priority_category,
        reason: params.reason,
        redirectPage: params.redirectPage,
        message_id: params.message_id,
      });
      return;
    }

    search.setQuery({
      modal: 'paywall-heart',
      dialogId: chatId ? dialogHistory?.id?.toString() : undefined,
      botName: chatId ? bot?.name : '',
      priority_category: bot?.priority_category,
      reason: params.reason,
      redirectPage: params.redirectPage,
      redirectModal: params.redirectModal,
      message_id: params.message_id,
    });
  };

  const close = ()=>{
    search.removeQuery([
      'modal',
      'redirectModal',
      'redirectPage',
      'dialogId',
      'botName',
      'priority_category',
      'reason',
      'message_id',
    ])
  }

  return {
    dialogHistory,
    bot,
    chatId,
    open,
    close,
    ...search,
  }
}